import { Component, h } from '@stencil/core';

@Component({
  tag: 'spw-table-row',
  styleUrl: 'spw-table-row.scss',
  shadow: true,
})
export class SpwTableRow {
  render() {
    return (
      <tr class="spw-table-row" part="row">
        <slot />
      </tr>
    );
  }
}
